/** @jsx h */
/** @jsxFrag Fragment */
import { h, Fragment } from "preact";

export type PrivacyProps = {
  privacyUrl: string;
  privacyUrlLabel: string;
};

const Privacy = ({ privacyUrl, privacyUrlLabel }: PrivacyProps) => {
  return (
    <p class="mt-16 text-xs leading-6 underline text-center">
      <a target="_blank" href={privacyUrl}>
        {privacyUrlLabel}
      </a>
    </p>
  );
};

export default Privacy;
